import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';
import SettingsGeneral from '@/components/SettingsGeneral';
import ProtocolsManager from '@/components/ProtocolsManager';
import StatisticsCharts from '@/components/StatisticsCharts';

const SettingsPage = () => {
  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Paramètres</h1>
        <p className="text-gray-600 mt-1">Configuration et gestion de l'application</p>
      </div>

      <Tabs defaultValue="general" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="general">Général</TabsTrigger>
          <TabsTrigger value="protocols">Protocoles</TabsTrigger>
          <TabsTrigger value="statistics">Statistiques</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="mt-6">
          <SettingsGeneral />
        </TabsContent>

        <TabsContent value="protocols" className="mt-6">
          <ProtocolsManager />
        </TabsContent>

        <TabsContent value="statistics" className="mt-6">
          <StatisticsCharts />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
